import { render, staticRenderFns } from "./tema.vue?vue&type=template&id=007ccaca&scoped=true"
import script from "./tema.vue?vue&type=script&lang=js"
export * from "./tema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ccaca",
  null
  
)

export default component.exports